import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey } from 'state/utils/collection';

import type { RealtimeQuoteBcsProductMap } from './bcsProduct.model';
import { initialProductMap } from './bcsProduct.model';

export function bcsProductReducer(
  state: RealtimeQuoteBcsProductMap = initialProductMap,
  action: Action,
): RealtimeQuoteBcsProductMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_BCS_PRODUCT_FETCHED':
      return addOrReplaceKey(state, action.key, { ...action.data, error: false });
    case 'SECONDARY_MARKET_BCS_PRODUCT_FETCH_REQUESTED':
      return addOrReplaceKey(state, action.key, { error: false });
    case 'SECONDARY_MARKET_BCS_PRODUCT_FETCH_FAILED':
      return patchKey(state, action.key, () => ({ error: true }));

    default:
      return state;
  }
}
